<template>
  <div>
    <BlockUI v-if="busy">
      <div class="loader"></div>
    </BlockUI>
  </div>
</template>
<script>
const API_URL = process.env.VUE_APP_API;
import { getLabelHtml, getLabelHtmlByTracking } from "@/axios/pos.js"

export default {
  name: "labelHtml",
  data() {
    return {
      busy: false
    }
  },
  async mounted() {
    await this.beforGetLabel()
  },
  methods: {
    async beforGetLabel(){
      if( this.$route.params.type && this.$route.params.type == 'dropoffShippop' ){

        this.getLabelDropoffShippop()
        
      }else if (this.$route.params.type && this.$route.params.type == 'orderByOne') {

        await this.getLabelHtmlByone()

      }else if (this.$route.params.type == 'VRich'){

        this.getLabelVRich()

      }else{

        await this.getLabelDefault()

      }
    },
    async getLabelHtmlByone() {
      this.busy = true
      const label = await getLabelHtml(
        this.$route.params.orderId, this.$route.params.label, this.$route.params.detailId
      )
      if (this.writeLabel(label)) {
        this.busy = false
      }
    },
    writeLabel(labelHtml) {
      window.document.write(labelHtml)
      setTimeout(() => {
         window.print()
      }, 500);
      return true
    },
    async getLabelDefault(){
      this.busy = true
      await this.$http
        .get(API_URL + "/order/"+this.$route.params.labelId+"/label/"+this.$route.params.size, {
          headers: {
            Token: localStorage.getItem("access_token")
          }
        })
        .then(res => {
          window.document.write(res.data.data); 
        })
      this.busy = false
    },
    getLabelDropoffShippop(){
      this.$http
            .post(
              this.$API_URL + "/dropoff/shippop/label",
              {
                tracking_code: null,
                order_id: this.$route.params.labelId,
                size: this.$route.params.size
              },
              {
                headers: {
                  Token: localStorage.getItem("access_token")
                }
              }
            )
            .then(res => {

                window.document.write(res.data.data.html)

            })
    },
    getLabelVRich(){
      this.$http
            .get(
              this.$API_URL + "/shippop/labels",
              {
                  headers: {
                      Token: localStorage.getItem("access_token")
                  },
                  params: {
                    tracking_codes: this.$route.params.labelId,
                    size: this.$route.params.size
                  }
              }
            )
            .then(res => {

                window.document.write(res.data.data.html)

            })
    }
  }
};
</script>
<style>
</style>